import fetchMock from  'fetch-mock';
import {delay, futureCalls} from "./mocks-lib";
import {ResponseMessage} from "./client";

if (process.env.USE_MOCKS === 'true') {
    mockGetServiceStatusesList();
    mockPatchServiceStatus();
    mockGetSpidActive();
    mockPutSpid();
    mockGetResponseMessages()
    mockPatchResponseMessage()
    mockGetClientStatus()
}

export function mockGetServiceStatusesList() {
    const GET_STATUSES_URL_MATCHER = "glob:*/service-statuses";

    function createServiceRow(name: string, emergency: boolean) {
        return { serviceName: name, emergency: emergency }
    }
    const predefServices = [
        createServiceRow("eSVD", true),
        createServiceRow("PDF", true),
        createServiceRow("SVD.se", true),
        createServiceRow("nilv.se", false),
        createServiceRow("korsord", false),
        createServiceRow("svdpdf", false),
        createServiceRow("All accesses endpoint", false)
    ];
    fetchMock.get(GET_STATUSES_URL_MATCHER, delay().then(() => predefServices ), { overwriteRoutes: true });
    return futureCalls(GET_STATUSES_URL_MATCHER)
}

export function mockPatchServiceStatus() {
    const PATCH_STATUS_URL_MATCHER = "glob:*/service-statuses/*";
    fetchMock.patch(PATCH_STATUS_URL_MATCHER , 200, { overwriteRoutes: true });
    return futureCalls(PATCH_STATUS_URL_MATCHER);
}

export function mockFailedPutService(errorMsg: string) {
    const PUT_STATUS_URL_MATCHER = "glob:*/service-statuses/*";
    const error = {"error": {"code": "SERVICE_ALREADY_EXIST", "message": errorMsg}};
    const response = {"body": error, "status": 400};
    fetchMock.put(PUT_STATUS_URL_MATCHER , delay().then(() => response), { overwriteRoutes: true });
    return futureCalls(PUT_STATUS_URL_MATCHER);
}

export function mockGetSpidActive() {
    const GET_SPID_URL_MATCHER = "glob:*/spid"
    fetchMock.get(GET_SPID_URL_MATCHER, delay().then(() => {return { active: false }} ), { overwriteRoutes: true });
    return futureCalls(GET_SPID_URL_MATCHER)
}

export function mockGetClientStatus() {
    const GET_CLIENT_URL_MATCHER = "glob:*/client-statuses"
    fetchMock.get(GET_CLIENT_URL_MATCHER, delay().then(() => {return []} ), { overwriteRoutes: true });
    return futureCalls(GET_CLIENT_URL_MATCHER)
}

export function mockPutSpid() {
    const PUT_SPID_URL_MATCHER = "glob:*/spid"
    fetchMock.put(PUT_SPID_URL_MATCHER , delay().then(() => {
        return 200
    }), { overwriteRoutes: true });
    return futureCalls(PUT_SPID_URL_MATCHER, "put");
}

export function mockPostLogin() {
    const LOGIN_URL_MATCHER = "glob:*/login";
    fetchMock.post(LOGIN_URL_MATCHER , 200, { overwriteRoutes: true });
    return futureCalls(LOGIN_URL_MATCHER);
}

export function mockPostLoginFailed() {
    const LOGIN_URL_MATCHER = "glob:*/login";
    fetchMock.post(LOGIN_URL_MATCHER , 401, { overwriteRoutes: true });
    return futureCalls(LOGIN_URL_MATCHER);
}

export function mockGetPermissions(permissions: string[]) {
    const PERMISSIONS_URL_MATCHER = "glob:*/permissions";
    fetchMock.get(PERMISSIONS_URL_MATCHER, delay().then(() => permissions), { overwriteRoutes: true });
    return futureCalls(PERMISSIONS_URL_MATCHER);
}

export function mockGetResponseMessages() {
    const GET_RESPONSE_MESSAGES_URL_MATCHER = "glob:*/response-messages"
    function createResponseMessagesRow(reason: string, reasonDescription: string, message: string, responseUrl: string): ResponseMessage {
        return { reason, reasonDescription, message, responseUrl }
    }
    const predefResponseMsgs = [
        createResponseMessagesRow("NOTFOUND",
            "No user found in SalesForce",
            "Ditt SPiD-konto verkar inte vara kopplat till SvD. Prova först att logga ut och sedan in igen. Fungerar ej det gå till SvD.se/uppdatera för att uppdatera din inloggning eller prova logga in med en annan e-postadress kopplad till SvD.",
            "https://kundservice.svd.se/uppdatera"),
        createResponseMessagesRow("INACTIVE",
            "No customer or subscription found",
            "Vi kan inte hitta någon aktiv prenumeration på din epostadress. Gå till SvD.se/minasidor för att se prenumerationsstatus och kontrollera dina uppgifter.",
            "https://kundservice.svd.se/Prenumeration-och-installningar"),
        createResponseMessagesRow("ONHOLD",
            "Subsctiption on hold",
            "Du har gjort ett uppehåll i din prenumeration. Då uppehållet passerat 100 dagar har du inte längre tillgång till denna tjänst. Återstarta din prenumeration för att ta del av tjänsten.",
            "https://kundservice.svd.se/Prenumeration-och-installningar"),
        createResponseMessagesRow("TIMEOUT",
            "Service unreachable",
            "Tjänsten går inte att nå för tillfället. Vänligen försök igen senare.",
            "https://kundservice.svd.se"),
    ];
    fetchMock.get(GET_RESPONSE_MESSAGES_URL_MATCHER, delay().then(() => predefResponseMsgs ), { overwriteRoutes: true });
    return futureCalls(GET_RESPONSE_MESSAGES_URL_MATCHER)
}

export function mockPatchResponseMessage() {
    const PATCH_RESPONSE_MESSAGE_URL_MATCHER = "glob:*/response-messages/*";
    fetchMock.patch(PATCH_RESPONSE_MESSAGE_URL_MATCHER , delay().then(() => 200), { overwriteRoutes: true });
    return futureCalls(PATCH_RESPONSE_MESSAGE_URL_MATCHER);
}
